import React, {useContext, useEffect, useRef, useState} from "react";
import useCreateUser from "./useCreateUser";
import AppbarActionButton from "../../../../commons/elements/buttons/AppbarActionButton";
import {Cancel, Save} from "@mui/icons-material";

import {AppbarContentContext} from "../../../../commons/routing/appbar/AppbarContentProvider";
import GeneralEditUserForm from "../utils/GeneralEditUserForm";
import {useIntl} from "react-intl";
import LoadingProgressIndication from "../../../../commons/elements/progress/loading/LoadingProgressIndication";

const NewUserSection = () => {
    // Hook to update the appbar
    const {setCurrentAppbarContent} = useContext(AppbarContentContext)

    // Hook providing the new user functionality
    const {create, saveInProgress, cancel} = useCreateUser()

    // Reference, which holds will hold the user data according to the current form data (from the general user component)
    const editedUserRef = useRef()

    // Determines if the save button should be enabled.
    const [saveButtonEnabled, setSaveButtonEnabled] = useState(false)

    // Internationalization for simple strings
    const intl = useIntl();

    // Setting the appbar content
    useEffect(() => {
        setCurrentAppbarContent({
            header: intl.formatMessage({
                id: 'app.users.new.appbar.header',
                defaultMessage: 'Create New User'
            }),
            description: intl.formatMessage({
                id: 'app.users.new.appbar.description',
                defaultMessage: 'Complete the form'
            }),
            actions: <>
                <AppbarActionButton
                    label={intl.formatMessage({
                        id: 'app.users.new.appbar.actions.save',
                        defaultMessage: 'Create'
                    })}
                    onClick={() => create(editedUserRef.current)}
                    icon={<Save/>}
                    disabled={!saveButtonEnabled}/>
                <AppbarActionButton
                    label={intl.formatMessage({
                        id: 'app.users.new.appbar.actions.cancel',
                        defaultMessage: 'Cancel'
                    })}
                    onClick={() => cancel()}
                    icon={<Cancel/>}/>
            </>,
            progress: saveInProgress
        })
    }, [saveButtonEnabled, saveInProgress])

    if (saveInProgress) {
        return <LoadingProgressIndication
            text={intl.formatMessage({
                id: 'app.users.new.save.loading',
                defaultMessage: 'Creating User...'
            })}/>
    }

    return (
        <GeneralEditUserForm editedUserRef={editedUserRef}
                             setSaveButtonEnabled={setSaveButtonEnabled}/>
    );
}

export default NewUserSection